import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-30-maxon-lewis-guest.webp";
import ThumbImg from "../../assets/images/conversations/blank.png";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";
import FacebookIcon from "../../assets/icons/conversations/facebook.svg";
import LinkedinIcon from "../../assets/icons/conversations/linkedin.svg";
import TwitterIcon  from "../../assets/icons/conversations/twitter.svg";

/* ─────────────────────────────────────────────
   PREFIX: cp-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .cp-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .cp-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .cp-hero { padding-top: 60px; padding-bottom: 60px; }
  .cp-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .cp-hero__left { display: flex; flex-direction: column; gap: 34px; }
  .cp-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .cp-hero__title.cp-visible { opacity: 1; transform: translateY(0); }

  /* social share buttons */
  .cp-hero__social {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s;
  }
  .cp-hero__social.cp-visible { opacity: 1; transform: translateY(0); }
  .cp-hero__social a {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 10px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  .cp-hero__social a:hover { opacity: 0.85; }
  .cp-hero__social a.fb { background: #3B5998; }
  .cp-hero__social a.li { background: #0077B5; }
  .cp-hero__social a.tw { background: #1DA1F2; }
  .cp-hero__social a img { width: 18px; height: 18px; flex-shrink: 0; }

  .cp-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .cp-hero__spotify.cp-visible { opacity: 1; transform: translateY(0); }
  .cp-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .cp-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .cp-hero__right.cp-visible { opacity: 1; transform: translateY(0); }

  .cp-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .cp-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .cp-yt-thumb:hover img { opacity: 0.85; }
  .cp-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .cp-yt-thumb__play img { width: 40px; height: 44px; }
  .cp-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .cp-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .cp-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .cp-body.cp-visible { opacity: 1; transform: translateY(0); }
  .cp-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .cp-body__para:last-child { margin-bottom: 0; }

  .cp-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .cp-guest.cp-visible { opacity: 1; transform: translateY(0); }
  .cp-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .cp-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .cp-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .cp-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .cp-inner { padding-left: 32px; padding-right: 32px; }
    .cp-hero { padding-top: 32px; padding-bottom: 48px; }
    .cp-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .cp-hero__title { font-size: 24px; }
    .cp-hero__left { gap: 16px; }
    .cp-hero__social { gap: 10px; }
    .cp-hero__social a { gap: 10px; font-size: 12px; padding: 10px 12px; }
    .cp-guest__title { font-size: 24px; margin-bottom: 24px; }
    .cp-guest__photo-bg { width: 260px; height: 300px; }
    .cp-guest__name { font-size: 24px; margin-top: 18px; }
    .cp-body__para { font-size: 14px; margin-bottom: 12px; }
    .cp-body { padding-bottom: 48px; }
    .cp-guest { padding-bottom: 48px; }
    .cp-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .cp-inner { padding-left: 16px; padding-right: 16px; }
    .cp-hero { padding-top: 51px; padding-bottom: 30px; }
    .cp-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .cp-hero__left { gap: 30px; }
    .cp-hero__title { font-size: 30px; }
    .cp-hero__social { gap: 11px; }
    .cp-hero__social a { gap: 10px; font-size: 15px; padding: 10px 14px; }
    .cp-body__para { font-size: 16px; margin-bottom: 10px; }
    .cp-guest__title { font-size: 30px; margin-bottom: 20px; }
    .cp-guest__photo-bg { width: 100%; height: 386px; }
    .cp-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .cp-body { padding-bottom: 30px; }
    .cp-guest { padding-bottom: 30px; }
    .cp-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("cp-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP30_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="cp-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 30 ChargePoint Operators"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="cp-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 30 ChargePoint Operators thumbnail" />
      <div className="cp-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const socialRef  = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(socialRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="cp-hero">
      <div className="cp-inner">
        <div className="cp-hero__grid">
          <div className="cp-hero__left">
            <div ref={titleRef} className="cp-hero__title">
              EP 30 | The ChargePoint Operators of India | GOEC | Charge Zone | Zeon | ChargeMod
            </div>
            <div ref={socialRef} className="cp-hero__social">
              <a href="https://www.facebook.com/sharer/sharer.php?u=" className="fb" target="_blank" rel="noreferrer">
                <img src={FacebookIcon} alt="Facebook" /> Facebook
              </a>
              <a href="https://www.linkedin.com/sharing/share-offsite/?url=" className="li" target="_blank" rel="noreferrer">
                <img src={LinkedinIcon} alt="LinkedIn" /> Linked in
              </a>
              <a href="https://twitter.com/intent/tweet?url=" className="tw" target="_blank" rel="noreferrer">
                <img src={TwitterIcon} alt="Twitter" /> Twitter
              </a>
            </div>
            <div ref={spotifyRef} className="cp-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/5QAl9gS4zrgibsWoqkhKKK?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 30 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="cp-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="cp-body">
      <div className="cp-inner">
        <p className="cp-body__para">
          In this episode, we've got to do something that is very unique and not normally possible. We were fortunate to have four opinionators: all CEOs of charge point operations companies in India, who visited our Artemis studio on the very same day. They were in Pune to be a part of the energizing India summit, an annual event held every November bringing together key CEOs and decision-makers from the entire clean mobility sector in India. It was one of the most special episode so far!
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="cp-guest">
      <div className="cp-inner">
        <h2 className="cp-guest__title">Our Guest</h2>
        <div>
          <div className="cp-guest__photo-bg">
            <img src={GuestImg} alt="Maxon Lewis" />
          </div>
          <p className="cp-guest__name">Maxon LEWIS</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep30ChargePointOperators() {
  return (
    <>
      <style>{CSS}</style>
      <div className="cp-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}